/*
 * @Author: Gang Jiang 
 * @Date: 2024-09-19 21:10:22 
 * @Last Modified by: Gang Jiang
 * @Last Modified time: 2024-11-13 15:32:14
 * @Description advertiser详情页
 */

<template>
  <div
    ref="zjdgx"
    class="advertiser-detail"
  >
    <div class="bread-crumb">
      Advertisers<span class="current">Advertiser Detail</span>
    </div>
    <h2>
      Advertiser Detail
      <div class="operates">
        <a
          v-if="detail"
          :href="'/#/advertiser/edit/' + detail.id"
        ><a-button type="primary">Edit</a-button></a>
        <a-button
          class="log"
          @click="setLogModalInfo"
        >
          Log
        </a-button>
        <a-dropdown
          class="more"
          :get-popup-container="() => $refs.zjdgx"
        >
          <span
            class="ant-dropdown-link"
            @click="(e) => e.preventDefault()"
          >
            ...
          </span>
          <template #overlay>
            <a-menu>
              <a-menu-item>
                <a-popconfirm
                  v-if="!detail.deleteForbidden"
                  title="Are you sure want to delete this Advertiser?"
                  ok-text="Confirm"
                  cancel-text="Cancel"
                  @confirm="deleteAdvertiser"
                >
                  <span class="delete"> Delete</span>
                </a-popconfirm>
                <span
                  v-else
                  class="delete disabled"
                >Delete</span>
              </a-menu-item>
            </a-menu>
          </template>
        </a-dropdown>
      </div>
    </h2>
    <div class="content">
      <div
        v-if="detail"
        class="detail"
      >
        <div class="logo">
          <img
            v-if="detail.logo"
            :src="detail.logo"
            :alt="detail.advertiserName"
          >
          <p v-else />
        </div>
        <div class="info">
          <div class="row">
            <div class="cell">
              <span class="label">Advertiser Name:</span>
              <span class="name">{{ detail.advertiserName }}</span>
            </div>
            <div class="cell">
              <span class="label">Advertiser ID:</span>
              <span class="name">{{ detail.id }}</span>
            </div>
            <div class="cell">
              <span class="label">Display Status:</span>
              <span :class="'name status ' + detail.displayStatus">{{
                detail.displayStatus
              }}</span>
            </div>
          </div>
          <div class="row">
            <div class="cell">
              <span class="label">Advertiser Region:</span>
              <span class="name">{{ detail.region.name }}</span>
            </div>
            <div class="cell">
              <span class="label">Domain:</span>
              <span class="name">{{ detail.domain }}</span>
            </div>
            <div class="cell">
              <span class="label">Path:</span>
              <span class="name">{{ detail.path || '-' }}</span>
            </div>
          </div>
          <div class="row">
            <div class="cell">
              <span class="label">Assigned AM:</span>
              <span class="name">{{ detail.assignedAm.name }}</span>
            </div>
            <div class="cell">
              <span class="label">Assigned IM:</span>
              <span class="name">{{ detail.assignedIm?.name || '-' }}</span>
            </div>
            <div class="cell">
              <span class="label">Category:</span>
              <span class="name">{{ detail.category.name }}</span>
            </div>
          </div>
          <div class="row">
            <div class="cell">
              <span class="label">Create Time:</span>
              <span class="name">{{
                moment(detail.createTime).format('YYYY-MM-DD HH:mm:ss')
              }}</span>
            </div>
            <div class="cell">
              <span class="label">Last Update Time:</span>
              <span class="name update-time">{{
                moment(detail.updateTime).format('YYYY-MM-DD HH:mm:ss')
              }}</span>
            </div>
            <div class="cell" />
          </div>
          <div class="row">
            <div class="cell">
              <span class="label">KOL rule:</span>
              <span class="name">{{ kolRuleText }}</span>
            </div>
          </div>
          <div class="row">
            <div class="cell">
              <span class="label">Merchant Threshold:</span>
              <span class="name">{{ salesThreshold.scopeEnabled ? 'Yes' : 'No' }}</span>
            </div>
            <template v-if="salesThreshold.scopeEnabled">
              <div class="cell">
                <span class="label">Monthly Limit:</span>
                <span class="name">{{ salesThreshold.monthlyLimit != null ? `$${salesThreshold.monthlyLimit}` : '-' }}</span>
              </div>
              <div class="cell">
                <span class="label">Daily Limit:</span>
                <span class="name">{{ salesThreshold.dailyLimit != null ? `$${salesThreshold.dailyLimit}` : '-' }}</span>
              </div>
            </template>
          </div>
          <div class="row">
            <div class="cell">
              <span class="label">Influencer Threshold:</span>
              <span class="name">{{ salesThreshold.influencerEnabled ? 'Yes' : 'No' }}</span>
            </div>
          </div>
          <div
            v-if="salesThreshold.influencerEnabled"
            class="row"
          >
            <div class="cell cell-full">
              <a-table
                class="influencer-threshold-table"
                size="small"
                :pagination="false"
                :columns="influencerThresholdColumns"
                :data-source="influencerThresholdList"
                row-key="influencerId"
              >
                <template #bodyCell="{ column, record }">
                  <template v-if="column.key === 'influencerName'">
                    {{ record.influencerName || record.userName || record.name || record.influencerId || '-' }}
                  </template>
                  <template v-else-if="column.key === 'dailyLimit'">
                    {{ formatLimitAmount(record.dailyLimit) }}
                  </template>
                  <template v-else-if="column.key === 'monthlyLimit'">
                    {{ formatLimitAmount(record.monthlyLimit) }}
                  </template>
                </template>
              </a-table>
            </div>
          </div>
          <div class="row">
            <div class="cell">
              <span class="label">Note:</span>
              <span class="name">{{ detail.note || '-' }}</span>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="detail && detail.affiliateList && detail.affiliateList.length"
        class="affiliate"
      >
        <h3>Affiliate({{ detail.affiliateList.length }})</h3>
        <Affiliate
          :advertiser-id="detail.id"
          :affiliate-list="detail.affiliateList"
          @setShowAffiliateLogId="setShowAffiliateLogId"
        />
      </div>
    </div>
    <LogModal
      v-if="showLogModal"
      :id="id"
      :container="$refs.zjdgx"
      :show-affiliate-log-id="showAffiliateLogId"
      @hideLogModal="hideLogModal"
    />
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'
import moment from 'moment'
import { useRoute } from 'vue-router'
import { advertiser } from '../../server/index'
import LogModal from '../../components/logModal.vue'
import Affiliate from '../../components/affiliate.vue'

const errMsg = ref('')
const route = useRoute()
const detail = ref(null)
const id = route.params.id
const showLogModal = ref(false)
const showAffiliateLogId = ref(-1)

const salesThreshold = computed(() => detail.value?.salesThreshold || {})

const kolRuleText = computed(() => {
  const item = detail.value
  if (!item) return '-'
  if (!item.kolRule) return 'No'
  const mode = String(item.kolRuleMode || item.ruleMode || '').toLowerCase()
  const rawList =
    mode === 'blacklist' ? item.kolBlackList : item.kolWhiteList
  const list = Array.isArray(rawList) ? rawList : []
  const names = list
    .map((kol) => {
      if (kol == null || typeof kol !== 'object') return ''
      return kol.name || kol.userName || ''
    })
    .filter(Boolean)
  const modeLabel =
    mode === 'blacklist' ? 'blackList' : mode === 'whitelist' ? 'whiteList' : mode
  if (names.length) {
    return `Yes (${modeLabel || 'list'}: ${names.join(', ')})`
  }
  return modeLabel ? `Yes (${modeLabel})` : 'Yes'
})

const influencerThresholdColumns = [
  { title: 'Influencer', dataIndex: 'influencerName', key: 'influencerName' },
  { title: 'DailyLimit', dataIndex: 'dailyLimit', key: 'dailyLimit' },
  { title: 'MonthlyLimit', dataIndex: 'monthlyLimit', key: 'monthlyLimit' },
]

const influencerThresholdList = computed(() => salesThreshold.value.items || [])

function formatLimitAmount(value) {
  if (value == null || value === '') return '-'
  const num = Number(value)
  if (Number.isNaN(num)) return String(value)
  return `$ ${num.toFixed(2)}`
}

advertiser.getDetail(id).then((res) => {
  if (res.success) {
    detail.value = res.data
  } else {
    errMsg.value = '获取Advertiser详情失败，请刷新重试！'
  }
})
const setLogModalInfo = () => {
  showLogModal.value = true
  showAffiliateLogId.value = -1
}
const hideLogModal = () => {
  showLogModal.value = false
}
const setShowAffiliateLogId = (id) => {
  showLogModal.value = true
  showAffiliateLogId.value = id
}
const deleteAdvertiser = () => {
  advertiser.delete(id).then((res) => {
    if (res.success) {
      location.href = '/#/advertisers'
    }
  })
}
</script>


<style lang="less" scoped>
.content {
  padding: 20px;
  margin-bottom: 20px;
}
.advertiser-detail {
  > h2 {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .operates {
      display: flex;
      font-size: 12px;
      align-items: center;
    }
    .log {
      margin-left: 10px;
    }
    .more {
      width: 30px;
      height: 32px;
      cursor: pointer;
      line-height: 32px;
      text-align: center;
    }
  }
  :deep(.delete) {
    color: #f00;
  }
  :deep(.disabled) {
    color: #999;
  }
}
.detail {
  display: flex;
  padding-bottom: 20px;
  &.no-commissions {
    padding-bottom: 0;
    border-bottom: none;
  }
  .logo {
    width: 160px;
    margin-right: 20px;
    > img {
      max-width: 100%;
    }
    > p {
      width: 160px;
      height: 160px;
      background-color: #f2f2f2;
    }
  }
  .info {
    flex: 1;
  }
  .row {
    width: 100%;
    display: flex;
    .cell {
      flex: 1;
      min-width: 0;
      display: flex;
      align-items: flex-start;
      line-height: 22px;
      margin-bottom: 10px;
      padding: 10px 12px 10px 0;
      box-sizing: border-box;
    }
    .label {
      flex-shrink: 0;
      color: #999;
      white-space: nowrap;
    }
    .name {
      flex: 1;
      min-width: 0;
      color: #000;
      margin-left: 10px;
      word-break: break-all;
      overflow-wrap: anywhere;
    }
    .status {
      margin: 0 0 0 20px;
      display: inline-block;
    }
    .update-time {
      white-space: nowrap;
    }
    .cell-full {
      flex: 1 1 100%;
      display: block;
    }
  }
  .influencer-threshold-table {
    width: 100%;
    max-width: 960px;
    :deep(.ant-table) {
      background: #fff;
    }
  }
}
.affiliate {
  > h3 {
    padding-bottom: 10px;
    margin-bottom: 0;
    border-bottom: 1px solid #e8e8e8;
  }
}
</style>